import { useState } from "react";

import { DialogTransition, IconButton, IconSearch, TrayModal } from "@/ui";

import { InlineGlobalSearch } from "./InlineGlobalSearch";

export const MobileGlobalSearch = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton icon={IconSearch} hideTooltip label="Search" onPress={() => setIsOpen(true)} />
      <DialogTransition>
        {isOpen && (
          <TrayModal onOpenChange={setIsOpen}>
            <InlineGlobalSearch openTrigger="mobile_button" onAction={() => setIsOpen(false)} />
          </TrayModal>
        )}
      </DialogTransition>
    </>
  );
};
